module.exports = __webpack_public_path__ + "img/sprinkle-4.cd54c025.jpg";